import logo from "./logo.svg";
import "./App.css";
import React, { Component, useState, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import Home from "./screens/Home";
import Upload from "./components/Upload";
import Mantra1_3 from "./components/Mantra1/mantra1_3";
import Mantra1 from "./components/Mantra1/mantra1_1";
import Mantra1_5 from "./components/Mantra1/mantra1_5";
import Mantra1_5_canvas from "./components/Mantra1/mantra1_5_canvas";
import Mantra1_6 from "./components/Mantra1/mantra1_6";
import Mantra_3_A1 from "./components/Mantra_3_A1";
import Mantra_3_A1_Edit from "./components/Mantra3/Mantra_3_A1_Edit";
import Mantra_3_A1_Share from "./components/Mantra3/Mantra_3_A1_Share";
import Loader from "./components/loader/loader";
import HomePageComponent from "./components/HomePageComponent";
import Mantra6_1 from "./components/Mantra6/mantra6_1";
import Mantra6_3 from "./components/Mantra6/mantra6_3";
import Mantra33_1 from "./components/Mantra33/mantra33_1";
import Mantra33_canvas from "./components/Mantra33/mantra33_canvas";
import Mantra33_3 from "./components/Mantra33/mantra33_3";
import Mantra33_4 from "./components/Mantra33/mantra33_4";
import Mantra33_5 from "./components/Mantra33/mantra33_5";
import Mantra33_6 from "./components/Mantra33/mantra33_6";
import Mantra_3_A1_Canvas from "./components/Mantra3/Mantra_3_A1_Canvas";
import Mantra_11_A1 from "./components/Mantra11/Mantra11_A1";
import Mantra_11_A1_Posted from "./components/Mantra11/Mantra_11_A1_Posted";
import Mantra_11_A1_Canvas from "./components/Mantra11/Mantra_11_A1_Canvas";
import Mantra_5_A1 from "./components/Mantra5/Mantra_5_A1";
import Congratulation from "./components/Congratulation";
import SharePopup from "./components/common/SharePopup";
import Mantra_18 from "./components/Mantra18/Mantra18";
import Mantra_18_Edit from "./components/Mantra18/Mantra_18_Edit";
import Mantra_18_Canvas from "./components/Mantra18/Mantra_18_Canvas";

import Mantra22 from './components/Mantra22/Mantra22';
import Mantra_22_Edit from './components/Mantra22/Mantra_22_Edit';
import Mantra_22_Canvas from './components/Mantra22/Mantra_22_Canvas';
import Mantra24 from './components/Mantra24/Mantra24';
import Mantra_24_Edit from './components/Mantra24/Mantra_24_Edit';
import Mantra_24_Canvas from './components/Mantra24/Mantra_24_Canvas';
import Mantra26 from './components/Mantra26/Mantra26';
import Mantra_26_Edit from './components/Mantra26/Mantra_26_Edit';
import Mantra_26_Canvas from './components/Mantra26/Mantra_26_Canvas';
import Mantra30 from './components/Mantra30/Mantra30';
import Mantra_30_Edit from './components/Mantra30/Mantra_30_Edit';
import Mantra_30_Canvas from './components/Mantra30/Mantra_30_Canvas';
import Mantra31 from './components/Mantra31/Mantra31';
import Mantra_31_Edit from './components/Mantra31/Mantra_31_Edit';
import Mantra_31_Canvas from './components/Mantra31/Mantra_31_Canvas';
import Mantra32 from './components/Mantra32/Mantra32';
import Mantra_32_Edit from './components/Mantra32/Mantra_32_Edit';
import Mantra_32_Canvas from './components/Mantra32/Mantra_32_Canvas';
import Mantra20 from './components/Mantra20/Mantra20';
import Mantra_20_Edit from './components/Mantra20/Mantra_20_Edit';
import Mantra_20_Canvas from './components/Mantra20/Mantra_20_Canvas';
import Mantra22b from './components/Mantra22b/Mantra22b';
import Mantra_22b_Edit from './components/Mantra22b/Mantra_22b_Edit';
import Mantra_22b_Canvas from './components/Mantra22b/Mantra_22b_Canvas';
import Mantra_2 from './components/Mantra2/Mantra2';
import Mantra_2_Edit from './components/Mantra2/Mantra_2_Edit';
import Mantra_2_Canvas from './components/Mantra2/Mantra_2_Canvas';
import Mantra_3N from './components/Mantra3N/Mantra_3N';
import Mantra_3N_Edit from './components/Mantra3N/Mantra_3N_Edit';
import Mantra_3N_Canvas from './components/Mantra3N/Mantra_3N_Canvas';
import Mantra_4N from './components/Mantra4N/Mantra_4N';
import Mantra_4N_Edit from './components/Mantra4N/Mantra_4N_Edit';
import Mantra_4N_Canvas from './components/Mantra4N/Mantra_4N_Canvas';
import Mantra_9N from './components/Mantra9N/Mantra_9N';
import Mantra_9N_Edit from './components/Mantra9N/Mantra_9N_Edit';
import Mantra_9N_Canvas from './components/Mantra9N/Mantra_9N_Canvas';
import Mantra_9N2 from './components/Mantra9N2/Mantra_9N2';
import Mantra_9N2_Edit from './components/Mantra9N2/Mantra_9N2_Edit';
import Mantra_9N2_Canvas from './components/Mantra9N2/Mantra_9N2_Canvas';
import Mantra_10N from './components/Mantra10N/Mantra_10N';

// details page
import Details from "./components/details/Details";
import Mantra_10N_Edit from "./components/Mantra10N/Mantra_10N_Edit";
import Mantra_10N_Canvas from "./components/Mantra10N/Mantra_10N_Canvas";
import Mantra_21_A2 from "./components/Mantra21_A2/Mantra_21_A2";
import Mantra_21_A2_Edit from "./components/Mantra21_A2/Mantra_21_A2_Edit";
import Mantra_21_A2_Canvas from "./components/Mantra21_A2/Mantra_21_A2_Canvas";
import Mantra_22_A1 from "./components/Mantra22_A1/Mantra_22_A1";
import Mantra_22_A1_Edit from "./components/Mantra22_A1/Mantra_22_A1_Edit";
import Mantra_22_A1_Canvas from "./components/Mantra22_A1/Mantra_22_A1_Canvas";
import Mantra_23_A1 from "./components/Mantra23_A1/Mantra_23_A1";
import Mantra_23_A1_Edit from "./components/Mantra23_A1/Mantra_23_A1_Edit";
import Mantra_23_A1_Canvas from "./components/Mantra23_A1/Mantra_23_A1_Canvas";
import Mantra29_A1 from "./components/Mantra29_A1/Mantra29_A1";
import Mantra29_A1_Edit from "./components/Mantra29_A1/Mantra29_A1_Edit";
import Mantra_29_A1_Canvas from "./components/Mantra29_A1/Mantra_29_A1_Canvas";
import Mantra_32_A1_Edit from "./components/Mantra32_A1/Mantra_32_A1_Edit";
import Mantra_32_A1_Canvas from "./components/Mantra32_A1/Mantra_32_A1_Canvas";
import Mantra_32_A2_Edit from "./components/Mantra32_A2/Mantra_32_A2_Edit";
import Mantra_32_A2_Canvas from "./components/Mantra32_A2/Mantra_32_A2_Canvas";
import Mantra_34_A1_Edit from "./components/Mantra34_A1/Mantra_34_A1_Edit";
import Mantra_34_A1_Canvas from "./components/Mantra34_A1/Mantra_34_A1_Canvas";
import Mantra_34_A2_Edit from "./components/Mantra34_A2/Mantra_34_A2_Edit";
import Mantra_34_A2_Canvas from "./components/Mantra34_A2/Mantra_34_A2_Canvas";
import Mantra13 from "./components/Mantra13/Mantra13";
import Mantra_13_Edit from "./components/Mantra13/Mantra_13_Edit";
import Mantra_13_Canvas from "./components/Mantra13/Mantra_13_Canvas";
import Mantra20_A1 from "./components/Mantra20_A1/Mantra20_A1";
import Mantra_20_A1_Edit from "./components/Mantra20_A1/Mantra_20_A1_Edit";
import Mantra_20_A1_Canvas from "./components/Mantra20_A1/Mantra_20_A1_Canvas";
import Mantra20_A2 from "./components/Mantra20_A2/Mantra20_A2";
import Mantra_20_A2_Edit from "./components/Mantra20_A2/Mantra_20_A2_Edit";
import Mantra_20_A2_Canvas from "./components/Mantra20_A2/Mantra_20_A2_Canvas";
import Mantra21_A1_New from "./components/Mantra21_A1_new/Mantra21_A1_New";
import Mantra_21_A1_New_Edit from "./components/Mantra21_A1_new/Mantra21_A1_New_Edit";
import Mantra_21_A1_New_Canvas from "./components/Mantra21_A1_new/Mantra_21_A1_New_Canvas";
import Mantra_25_New_Canvas from "./components/Mantra25_New/Mantra_25_New_Canvas";
import Mantra_25_New_Edit from "./components/Mantra25_New/Mantra_25_New_Edit";
import Mantra_25_New from "./components/Mantra25_New/Mantra_25_New";
import Mantra_12_New from "./components/Mantra12_New/Mantra_12_New";
import Mantra_12_New_Edit from "./components/Mantra12_New/Mantra_12_New_Edit";
import Mantra_12_New_Canvas from "./components/Mantra12_New/Mantra_12_New_Canvas";

function App() {
  // const [num,] = useState()
  useEffect(() => {
    if (!localStorage.getItem("org_url")) {
      localStorage.setItem("org_url", window.location.href);
    }
  }, []);
  return (
    <BrowserRouter>
      <div>
        {/* <TopBanner history={this.props} /> */}
        <Congratulation random={Math.random()} />
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <Route exact path="/mantra1" component={Mantra1} />
          <Route exact path="/mantra1_3" component={Mantra1_3} />
          <Route exact path="/mantra3" component={Mantra_3_A1} />
          <Route exact path="/mantra3_form" component={Mantra_3_A1_Edit} />
          <Route exact path="/mantra3_share" component={Mantra_3_A1_Share} />
          <Route exact path="/mantra6_1" component={Mantra6_1} />
          <Route exact path="/mantra3_canvas" component={Mantra_3_A1_Canvas} />
          <Route exact path="/mantra1_5" component={Mantra1_5} />
          <Route exact path="/mantra1_5_canvas" component={Mantra1_5_canvas} />
          <Route exact path="/mantra1_6" component={Mantra1_6} />
          <Route exact path="/mantra6_1" component={Mantra6_1} />
          <Route exact path="/mantra6_3" component={Mantra6_3} />

          <Route exact path="/mantra33_1" component={Mantra33_1} />
          <Route exact path="/mantra33_canvas" component={Mantra33_canvas} />
          <Route exact path="/mantra33_3" component={Mantra33_3} />
          <Route exact path="/mantra33_4" component={Mantra33_4} />
          <Route exact path="/mantra33_5" component={Mantra33_5} />
          <Route exact path="/mantra33_6" component={Mantra33_6} />
          <Route exact path="/mantra11" component={Mantra_11_A1} />
          <Route
            exact
            path="/mantra11_posted"
            component={Mantra_11_A1_Posted}
          />
          <Route
            exact
            path="/mantra11_canvas"
            component={Mantra_11_A1_Canvas}
          />
          <Route exact path="/mantra5" component={Mantra_5_A1} />
          <Route exact path="/congratulation" component={Congratulation} />
          <Route exact path="/mantra18" component={Mantra_18} />
          <Route exact path="/mantra18_edit" component={Mantra_18_Edit} />
          <Route exact path="/mantra18_canvas" component={Mantra_18_Canvas} />
          <Route exact path='/mantra22' component={Mantra22} />
          <Route exact path='/mantra22_edit' component={Mantra_22_Edit} />
          <Route exact path='/mantra22_canvas' component={Mantra_22_Canvas} />
          <Route exact path='/mantra24' component={Mantra24} />
          <Route exact path='/mantra24_edit' component={Mantra_24_Edit} />
          <Route exact path='/mantra24_canvas' component={Mantra_24_Canvas} />
          <Route exact path='/mantra26' component={Mantra26} />
          <Route exact path='/mantra26_edit' component={Mantra_26_Edit} />
          <Route exact path='/mantra26_canvas' component={Mantra_26_Canvas} />
          <Route exact path='/mantra30' component={Mantra30} />
          <Route exact path='/mantra30_edit' component={Mantra_30_Edit} />
          <Route exact path='/mantra30_canvas' component={Mantra_30_Canvas} />
          <Route exact path='/mantra31' component={Mantra31} />
          <Route exact path='/mantra31_edit' component={Mantra_31_Edit} />
          <Route exact path='/mantra31_canvas' component={Mantra_31_Canvas} />
          <Route exact path='/mantra32' component={Mantra32} />
          <Route exact path='/mantra32_edit' component={Mantra_32_Edit} />
          <Route exact path='/mantra32_canvas' component={Mantra_32_Canvas} />
          <Route exact path='/mantra20' component={Mantra20} />
          <Route exact path='/mantra20_edit' component={Mantra_20_Edit} />
          <Route exact path='/mantra20_canvas' component={Mantra_20_Canvas} />
          <Route exact path='/mantra22b' component={Mantra22b} />
          <Route exact path='/mantra22b_edit' component={Mantra_22b_Edit} />
          <Route exact path='/mantra22b_canvas' component={Mantra_22b_Canvas} />
          <Route exact path='/mantra2' component={Mantra_2} />
          <Route exact path='/mantra2_edit' component={Mantra_2_Edit} />
          <Route exact path='/mantra2_canvas' component={Mantra_2_Canvas} />
          <Route exact path='/mantra3n' component={Mantra_3N} />
          <Route exact path='/mantra3n_edit' component={Mantra_3N_Edit} />
          <Route exact path='/mantra3n_canvas' component={Mantra_3N_Canvas} />
          <Route exact path='/mantra4n' component={Mantra_4N} />
          <Route exact path='/mantra4n_edit' component={Mantra_4N_Edit} />
          <Route exact path='/mantra4n_canvas' component={Mantra_4N_Canvas} />
          <Route exact path='/mantra9n' component={Mantra_9N} />
          <Route exact path='/mantra9n_edit' component={Mantra_9N_Edit} />
          <Route exact path='/mantra9n_canvas' component={Mantra_9N_Canvas} />
          <Route exact path='/mantra9n2' component={Mantra_9N2} />
          <Route exact path='/mantra9n2_edit' component={Mantra_9N2_Edit} />
          <Route exact path='/mantra9n2_canvas' component={Mantra_9N2_Canvas} />
          <Route exact path='/mantra10n' component={Mantra_10N} />
          <Route exact path='/mantra10n_edit' component={Mantra_10N_Edit} />
          <Route exact path='/mantra10n_canvas' component={Mantra_10N_Canvas} />
          <Route exact path='/mantra21_a2' component={Mantra_21_A2} />
          <Route exact path='/mantra21_a2_edit' component={Mantra_21_A2_Edit} />
          <Route exact path='/mantra21_a2_canvas' component={Mantra_21_A2_Canvas} />
          <Route exact path='/mantra22_a1' component={Mantra_22_A1} />
          <Route exact path='/mantra22_a1_edit' component={Mantra_22_A1_Edit} />
          <Route exact path='/mantra22_a1_canvas' component={Mantra_22_A1_Canvas} />
          <Route exact path='/mantra23_a1' component={Mantra_23_A1} />
          <Route exact path='/mantra23_a1_edit' component={Mantra_23_A1_Edit} />
          <Route exact path='/mantra23_a1_canvas' component={Mantra_23_A1_Canvas} />
          <Route exact path='/mantra29_a1' component={Mantra29_A1} />
          <Route exact path='/mantra29_a1_edit' component={Mantra29_A1_Edit} />
          <Route exact path='/mantra29_a1_canvas' component={Mantra_29_A1_Canvas} />
          <Route exact path='/mantra32_a1_edit' component={Mantra_32_A1_Edit} />
          <Route exact path='/mantra32_a1_canvas' component={Mantra_32_A1_Canvas} />
          <Route exact path='/mantra32_a2_edit' component={Mantra_32_A2_Edit} />
          <Route exact path='/mantra32_a2_canvas' component={Mantra_32_A2_Canvas} />
          <Route exact path='/mantra34_a1_edit' component={Mantra_34_A1_Edit} />
          <Route exact path='/mantra34_a1_canvas' component={Mantra_34_A1_Canvas} />
          <Route exact path='/mantra34_a2_edit' component={Mantra_34_A2_Edit} />
          <Route exact path='/mantra34_a2_canvas' component={Mantra_34_A2_Canvas} />
          <Route exact path='/mantra13' component={Mantra13} />
          <Route exact path='/mantra13_edit' component={Mantra_13_Edit} />
          <Route exact path='/mantra13_canvas' component={Mantra_13_Canvas} />
          <Route exact path='/mantra20_a1' component={Mantra20_A1} />
          <Route exact path='/mantra20_a1_edit' component={Mantra_20_A1_Edit} />
          <Route exact path='/mantra20_a1_canvas' component={Mantra_20_A1_Canvas} />
          <Route exact path='/mantra20_a2' component={Mantra20_A2} />
          <Route exact path='/mantra20_a2_edit' component={Mantra_20_A2_Edit} />
          <Route exact path='/mantra20_a2_canvas' component={Mantra_20_A2_Canvas} />
          <Route exact path='/mantra21_a1_new' component={Mantra21_A1_New} />
          <Route exact path='/mantra21_a1_edit_new' component={Mantra_21_A1_New_Edit} />
          <Route exact path='/mantra21_a1_canvas_new' component={Mantra_21_A1_New_Canvas} />
          <Route exact path='/mantra25_new' component={Mantra_25_New} />
          <Route exact path='/mantra25_new_edit' component={Mantra_25_New_Edit} />
          <Route exact path='/mantra25_new_canvas' component={Mantra_25_New_Canvas} />
          <Route exact path='/mantra12_new' component={Mantra_12_New} />
          <Route exact path='/mantra12_new_edit' component={Mantra_12_New_Edit} />
          <Route exact path='/mantra12_new_canvas' component={Mantra_12_New_Canvas} />

          {/* details page */}
          <Route exact path="/:postId" component={Details} />
          

          {/* <Route exact path='/loader' component={Loader} /> */}
          {/* <Route path='/t10serieswinner' component={T10SeriesWinnerComponent} />
          <Route exact path='/mywarriormoment' component={MyWarriorMomentComponent} />*/}
          <Route
            listen
            path="/:type/:name?/:language?"
            component={HomePageComponent}
          />
        </Switch>
        <SharePopup />
      </div>
    </BrowserRouter>
  );
}

export default App;
